export default {
  // 数据统计
  totalData: "共计{count}条数据",

  // 加载
  loading: "拼命加载中",

  // 表格列
  currency: "币种",
  balance: "余额",

  // 空状态
  noWalletData: "当前调证文件中未解析到钱包余额数据",

  // 下载
  downloadDetails: "下载数据明细",
  downloadFileName: "数据明细",
};
